import React from "react";
import styled from "styled-components";
import { InnerLayout } from "../styles/Layouts";
import Title from "../Components/Title";
import SmallTitle from "../Components/SmallTitle";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import SchoolIcon from "@material-ui/icons/School";
import ResumeItem from "../Components/ResumeItem";
import goals from "../img/goals.png";

function Resume() {
  const briefcase = <BusinessCenterIcon />;
  const school = <SchoolIcon />;
  return (
    <ResumeStyled>
      <Title title={"Resume"} span={"resume"} />
      <InnerLayout>
        <div className="small-title">
          <SmallTitle icon={briefcase} title={"Pengalaman"} />
        </div>
        <div className="resume-content">
          <ResumeItem
            year={"2019 - 2020"}
            title={"Web Developer"}
            subTitle={"Project SPP-IRT"}
            text={
              "Pengembangan sistem SPP-IRT berbasis web dengan konsep MVC, menggunakan framework PHP Codeigniter 3, dan Jquery di BPOM RI"
            }
          />
          <ResumeItem
            year={"2020"}
            title={"Web Developer"}
            subTitle={"Project GKPD"}
            text={
              "Pengembangan sistem GKPD berbasis web dengan konsep MVC, menggunakan framework PHP Codeigniter 3, dan Jquery di BPOM RI "
            }
          />
          <ResumeItem
            year={"2020 - 2021"}
            title={"Web Developer"}
            subTitle={"Project E-Perda"}
            text={
              "Membangun sistem E-Perda berbasis web dengan konsep MVC, menggunakan framework PHP Codeigniter 3, dan Jquery di instansi Kemendagri Dirjen Otonomi Daerah"
            }
          />
          <ResumeItem
            year={"2021 - Sekarang"}
            title={"Android Apps"}
            subTitle={"Project e-Cotoursim"}
            text={
              "Membangun aplikasi android dengan React Native. e-Cotoursim merupakan sebuah inovasi karya kami untuk membantu pengelolaan konten dan memebrikan informasi seperti kuliner, wisata di Bogor Raya untuk para wisatawan yang saat ini masih tahap pengembangan"
            }
          />
          <ResumeItem
            year={"2021 - Sekarang"}
            title={"Fullstack Developer"}
            subTitle={"Project LMS"}
            text={
              "Membangun sistem Learning Management Sistem (LMS) berbasis web, bertanggung jawab pada bagian frontend dan backend, menggunakan framework React.js, Node.js/express.js"
            }
          />
          <ResumeItem
            year={"2021 - Sekarang"}
            title={"Fullstack Developer"}
            subTitle={"PT. AMA SALAM INDONESIA"}
            text={
              "Staff developer di PT. AMA SALAM INDONESIA, bertanggung jawab pada bagian frontend dan backend, menggunakan framework React.js, Node.js/express.js, serta suport pengembangan pada bagian aplikasi MVC yang menggunakan Codeigniter 3"
            }
          />
        </div>
        <div className="small-title u-small-title-margin">
          <SmallTitle icon={school} title={"Pendidikan"} />
        </div>
        <div className="resume-content ">
          <ResumeItem
            year={"2014 - 2017"}
            title={"MIPA"}
            subTitle={"SMAN 1 CIAMPEA"}
          />
          <ResumeItem
            year={"2017 - 2021"}
            title={"Teknik Informatika"}
            subTitle={"Universitas Ibn Khaldun Bogor"}
            text={
              "Lulusan Sarjana Teknik Informatika dengan predikat kelulusan Cumlaude"
            }
          />
        </div>
        <div className="small-title u-small-title-margin">
          <SmallTitle image={goals} title={"Pencapaian/Organisasi"} />
        </div>
        <div className="resume-content ">
          <ResumeItem
            year={"2019 - 2020"}
            title="Ketua Devisi Riset dan Teknologi"
            subTitle={"HIMATEKINFO UIKA"}
            text={
              "Menjabat sebagai ketua devisi bidang riset dan teknologi pada organisasi Himpunan Mahasiswa Teknik Informtika (HIMATEKINFO) UIKA Bogor"
            }
          />
          <ResumeItem
            year={"2020"}
            title={"Juara 1 - Tingkat Kabupaten"}
            subTitle={"Gelar Inovasi Daerah Kab.Bogor 2020"}
            text={
              "Mendapatkan Peringkat pertama pada ajang kompetesi inovasi daerah yang di senggelarakan oleh Bappedalitbang Kabupaten Bogor, dengan inovasi Prototype Booking Sport berbasis Mobile Application"
            }
          />
         
        </div>
      </InnerLayout>
    </ResumeStyled>
  );
}

const ResumeStyled = styled.section`
  .small-title {
    padding-bottom: 3rem;
  }
  .u-small-title-margin {
    margin-top: 4rem;
  }

  .resume-content {
    border-left: 2px solid var(--border-color);
  }
`;
export default Resume;
